namespace SorAraBul.Definitions {
    export interface QuartersForm {
        CountryId: Serenity.ServiceLookupEditor;
        IlceCityId: Serenity.ServiceLookupEditor;
        IlceId: Serenity.ServiceLookupEditor;
        Name: Serenity.StringEditor;
        DistrictName: Serenity.StringEditor;
        DistrictId: Serenity.IntegerEditor;
    }

    export class QuartersForm extends Serenity.PrefixedContext {
        static formKey = 'Definitions.Quarters';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QuartersForm.init)  {
                QuartersForm.init = true;

                var s = Serenity;
                var w0 = s.ServiceLookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(QuartersForm, [
                    'CountryId', w0,
                    'IlceCityId', w0,
                    'IlceId', w0,
                    'Name', w1,
                    'DistrictName', w1,
                    'DistrictId', w2
                ]);
            }
        }
    }
}
